var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2500px",
    height: "1271px",
    viewBox: "0 0 2500 1271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M622.824221,103.819588 L622.824221,119.829504 L854.267654,119.829504 L854.267654,180.47771 L849.909933,180.47771 L849.909933,197.943073 L832.479047,197.943073 L832.479047,962.052705 L364.267239,962.052705 L364.267239,103.819588 L622.824221,103.819588 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M2231.79185,99.9383963 L2231.79185,945.55764 L1742.75982,945.55764 L1742.75982,887.339763 L1313.76518,887.339763 L1313.76518,962.052705 L835.385356,962.052705 L835.385356,476.426913 L1054.72401,478.367509 L1054.72401,119.829504 L1282.29391,119.829504 L1282.29391,99.9498837 L1772.29433,103.808191 L1772.29433,180.47771 L1768.90499,180.47771 L1768.90499,197.943073 L1751.4741,197.943073 L1751.4741,405.0971 L1768.90499,405.0971 L1768.90499,478.354595 L1992.60252,478.354595 L1992.60252,427.903686 L1975.16104,427.903686 L1972.76135,99.9383963 L2231.79185,99.9383963 Z",
    stroke: "#FFD426",
    strokeWidth: 2.90630975,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor2);
export default __webpack_public_path__ + "static/media/select-floor-2.bef83c4e.svg";
export { ForwardRef as ReactComponent };